(function () {
  "use strict";

  var $ = function (s, ctx) { return (ctx || document).querySelector(s); };
  var $$ = function (s, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(s)); };
  var money = function (cents) {
    if (typeof cents !== "number") return cents;
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.themeMoneyFormat || "${{amount}}")
      : "$" + (cents / 100).toFixed(2);
  };
  var preorderPct = (window.themePreorder && window.themePreorder.enabled) ? (Number(window.themePreorder.percent) || 0) : 0;
  var preorderCents = function (cents) {
    return preorderPct > 0 ? Math.round(cents * (100 - preorderPct) / 100) : cents;
  };
  // returns markup: plain price, or strikethrough original + discounted price when preorder discount is active
  var priceMarkup = function (cents) {
    if (preorderPct <= 0) return money(cents);
    return '<span class="price-compare">' + money(cents) + "</span> " + money(preorderCents(cents));
  };

  /* ---------------------------------------------------------
     PRODUCT BUY SECTIONS (variant + selling plan + qty + add)
  --------------------------------------------------------- */
  function initProductSections() {
    $$("[data-product-section]").forEach(function (root) {
      var scriptEl = root.querySelector('script[id^="ProductJson-"]');
      if (!scriptEl) return;
      var product;
      try { product = JSON.parse(scriptEl.textContent); } catch (e) { return; }

      var sectionId = scriptEl.id.replace("ProductJson-", "");
      var form = $("#buyForm-" + sectionId, root) || root.querySelector("form[data-product-form]");
      var variantIdInput = form ? form.querySelector('input[name="id"]') : null;
      var sellingPlanInput = form ? form.querySelector('input[name="selling_plan"]') : null;
      var sizeButtons = $$("#sizes-" + sectionId + " .size", root);
      var planButtons = $$("#plans-" + sectionId + " .plan", root);
      var qtyInput = $("#qInput-" + sectionId, root);
      var qMinus = $("#qMinus-" + sectionId, root);
      var qPlus = $("#qPlus-" + sectionId, root);
      var buyTotal = $("#buyTotal-" + sectionId, root);
      var addBtn = $("#addCart-" + sectionId, root);
      var galMain = $("#galMain-" + sectionId, root);
      var thumbs = $$("#thumbs-" + sectionId + " button", root);

      var state = {
        variantId: sizeButtons.length ? parseInt(sizeButtons[0].dataset.variantId, 10) : (product.variants[0] && product.variants[0].id),
        sellingPlanId: null,
        qty: 1
      };

      function currentVariant() {
        var id = state.variantId;
        var v = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].id === id) { v = product.variants[i]; break; }
        }
        return v || product.variants[0];
      }

      function unitPriceCents() {
        var v = currentVariant();
        if (!state.sellingPlanId) return v.price;
        var allocs = v.selling_plan_allocations || [];
        for (var i = 0; i < allocs.length; i++) {
          if (allocs[i].selling_plan_id === state.sellingPlanId) return allocs[i].price;
        }
        return v.price;
      }

      function renderPrices() {
        var v = currentVariant();
        if (planButtons.length) {
          planButtons.forEach(function (btn) {
            var pid = btn.dataset.sellingPlan ? parseInt(btn.dataset.sellingPlan, 10) : null;
            var priceEl = btn.querySelector(".plan-price");
            if (!priceEl) return;
            if (!pid) {
              priceEl.innerHTML = priceMarkup(v.price);
            } else {
              var allocs = v.selling_plan_allocations || [];
              var alloc = null;
              for (var i = 0; i < allocs.length; i++) {
                if (allocs[i].selling_plan_id === pid) { alloc = allocs[i]; break; }
              }
              priceEl.innerHTML = priceMarkup(alloc ? alloc.price : v.price);
            }
          });
        }
        if (preorderPct > 0) {
          sizeButtons.forEach(function (btn) {
            var id = parseInt(btn.dataset.variantId, 10);
            var vv = null;
            for (var i = 0; i < product.variants.length; i++) {
              if (product.variants[i].id === id) { vv = product.variants[i]; break; }
            }
            var priceEl = btn.querySelector(".sp");
            if (priceEl && vv) priceEl.innerHTML = priceMarkup(vv.price);
          });
        }
        if (buyTotal) buyTotal.innerHTML = priceMarkup(unitPriceCents() * state.qty);
        var sbPrice = $("#sbPrice");
        if (sbPrice) sbPrice.innerHTML = priceMarkup(unitPriceCents() * state.qty);
      }

      // size / variant selection
      sizeButtons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (btn.hasAttribute("disabled")) return;
          sizeButtons.forEach(function (b) { b.classList.remove("active"); });
          btn.classList.add("active");
          state.variantId = parseInt(btn.dataset.variantId, 10);
          if (variantIdInput) variantIdInput.value = state.variantId;
          var v = currentVariant();
          if (v && v.featured_image && galMain) {
            galMain.src = v.featured_image.src ? v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, "$1") : galMain.src;
          }
          renderPrices();
        });
      });

      // subscription / selling plan selection
      planButtons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          planButtons.forEach(function (b) { b.classList.remove("active"); });
          btn.classList.add("active");
          state.sellingPlanId = btn.dataset.sellingPlan ? parseInt(btn.dataset.sellingPlan, 10) : null;
          if (sellingPlanInput) {
            if (state.sellingPlanId) {
              sellingPlanInput.value = state.sellingPlanId;
              sellingPlanInput.removeAttribute("disabled");
            } else {
              sellingPlanInput.value = "";
              sellingPlanInput.setAttribute("disabled", "disabled");
            }
          }
          renderPrices();
        });
      });

      // quantity
      function setQty(v) {
        v = Math.max(1, Math.min(20, v || 1));
        state.qty = v;
        if (qtyInput) qtyInput.value = v;
        renderPrices();
      }
      if (qMinus) qMinus.addEventListener("click", function () { setQty(state.qty - 1); });
      if (qPlus) qPlus.addEventListener("click", function () { setQty(state.qty + 1); });
      if (qtyInput) qtyInput.addEventListener("input", function () { setQty(parseInt(qtyInput.value, 10)); });

      // gallery thumbs
      thumbs.forEach(function (btn) {
        btn.addEventListener("click", function () {
          thumbs.forEach(function (b) { b.classList.remove("active"); });
          btn.classList.add("active");
          if (galMain) galMain.src = btn.dataset.img;
        });
      });

      // add to cart — bind to the FORM's submit event (not just a button click) so this
      // fires whether the click came from this button, the Enter key, or an app's own
      // script (e.g. a preorder app) that swaps the button and calls form.requestSubmit().
      if (form && addBtn) {
        form.addEventListener("submit", function (evt) {
          evt.preventDefault();
          if (addBtn.hasAttribute("disabled")) return;
          var originalText = addBtn.textContent;
          addBtn.setAttribute("disabled", "disabled");
          addBtn.textContent = "Adding…";

          var formData = new FormData(form);
          // keep quantity in sync with the qty stepper state
          formData.set("quantity", state.qty);
          // force selling_plan to match OUR selected plan exactly, even if another
          // script (e.g. a preorder app) has injected its own hidden selling_plan
          // field into this form — prevents "one-time purchase" silently checking
          // out as a subscription.
          formData.delete("selling_plan");
          if (state.sellingPlanId) formData.set("selling_plan", state.sellingPlanId);

          fetch(cartUrl("/cart/add.js"), {
            method: "POST",
            headers: { Accept: "application/json" },
            body: formData
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              addBtn.textContent = "Added";
              return refreshCart().then(function () {
                openCart();
                setTimeout(function () { addBtn.textContent = originalText; addBtn.removeAttribute("disabled"); }, 900);
              });
            })
            .catch(function () {
              addBtn.textContent = originalText;
              addBtn.removeAttribute("disabled");
            });
        });
      }

      renderPrices();
    });
  }

  /* ---------------------------------------------------------
     CART DRAWER (real Shopify cart via AJAX API)
  --------------------------------------------------------- */
  var drawer = $("#drawer");
  var overlay = $("#overlay");
  var drawerBody = $("#drawerBody");
  var drawerFoot = $("#drawerFoot");
  var subTotalEl = $("#subTotal");
  var cartCountEl = $("#cartCount");

  function cartUrl(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
    return root.replace(/\/$/, "") + path;
  }

  function refreshCart() {
    return fetch(cartUrl("/cart.js"), { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function renderCart(cart) {
    if (!drawerBody) return;
    var count = cart.item_count || 0;
    if (cartCountEl) {
      cartCountEl.textContent = count;
      cartCountEl.classList.toggle("show", count > 0);
    }

    if (!cart.items || cart.items.length === 0) {
      drawerBody.innerHTML =
        '<div class="cart-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">' +
        '<circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/>' +
        '<path d="M2 3h3l2.4 12.2a1.6 1.6 0 0 0 1.6 1.3h8.4a1.6 1.6 0 0 0 1.6-1.3L22 7H6"/></svg>' +
        "<p>Your cart is empty.<br>Kind wipes are just a tap away.</p></div>";
      if (drawerFoot) drawerFoot.style.display = "none";
      return;
    }

    drawerBody.innerHTML = "";
    cart.items.forEach(function (item, i) {
      var planLabel = item.selling_plan_allocation
        ? item.selling_plan_allocation.selling_plan.name
        : "One-time";
      var el = document.createElement("div");
      el.className = "ci";
      el.innerHTML =
        '<img src="' + (item.image || "") + '" alt="">' +
        '<div class="cim"><b>' + item.product_title + "</b>" +
        '<span class="cv">' + (item.variant_title || "") + " · " + planLabel + "</span>" +
        '<div class="miniqty">' +
        '<button type="button" data-a="dec" data-key="' + item.key + '" data-qty="' + item.quantity + '">−</button>' +
        "<span>" + item.quantity + "</span>" +
        '<button type="button" data-a="inc" data-key="' + item.key + '" data-qty="' + item.quantity + '">+</button>' +
        "</div></div>" +
        '<div class="cip"><b>' + money(item.final_line_price) + "</b><br>" +
        '<button type="button" class="cr" data-a="rm" data-key="' + item.key + '">Remove</button></div>';
      drawerBody.appendChild(el);
    });

    if (drawerFoot) {
      drawerFoot.style.display = "block";
      if (subTotalEl) subTotalEl.textContent = money(cart.total_price);
    }
  }

  if (drawerBody) {
    drawerBody.addEventListener("click", function (e) {
      var btn = e.target.closest("button[data-a]");
      if (!btn) return;
      var key = btn.dataset.key;
      var a = btn.dataset.a;
      var qty = parseInt(btn.dataset.qty || "0", 10);
      var newQty = a === "inc" ? qty + 1 : a === "dec" ? qty - 1 : 0;

      fetch(cartUrl("/cart/change.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
        .then(function (r) { return r.json(); })
        .then(renderCart);
    });
  }

  function openCart() {
    if (!drawer) return;
    drawer.classList.add("show");
    overlay.classList.add("show");
    drawer.setAttribute("aria-hidden", "false");
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("show");
    overlay.classList.remove("show");
    drawer.setAttribute("aria-hidden", "true");
  }

  var cartOpenBtn = $("#cartOpen");
  var drawerCloseBtn = $("#drawerClose");
  var checkoutBtn = $("#checkoutBtn");
  var sbAddBtn = $("#sbAdd");

  if (cartOpenBtn) cartOpenBtn.addEventListener("click", function () { refreshCart(); openCart(); });
  if (drawerCloseBtn) drawerCloseBtn.addEventListener("click", closeCart);
  if (overlay) overlay.addEventListener("click", closeCart);
  if (checkoutBtn) checkoutBtn.addEventListener("click", function () { window.location.href = cartUrl("/checkout"); });
  if (sbAddBtn) {
    sbAddBtn.addEventListener("click", function () {
      var firstForm = $("form[data-product-form]");
      if (firstForm) {
        if (firstForm.requestSubmit) firstForm.requestSubmit();
        else firstForm.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
      } else {
        var firstAdd = $(".add-to-cart");
        if (firstAdd) firstAdd.click();
        else window.location.hash = "#shop";
      }
    });
  }

  // keep the sticky bar button label in sync with the main Add to cart button —
  // covers the case where a preorder app swaps its text (e.g. to "Pre-Order").
  (function syncStickyBarLabel() {
    var mainAdd = $(".add-to-cart");
    if (!mainAdd || !sbAddBtn || !("MutationObserver" in window)) return;
    var apply = function () {
      var t = mainAdd.textContent.trim();
      if (t && t !== "Adding…" && t !== "Added") sbAddBtn.textContent = t;
    };
    apply();
    new MutationObserver(apply).observe(mainAdd, { childList: true, characterData: true, subtree: true });
  })();

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeCart();
  });

  /* ---------------------------------------------------------
     HEADER SCROLL + STICKY BUY BAR + REVEAL ON SCROLL
  --------------------------------------------------------- */
  var hdr = $("#hdr");
  var sb = $("#stickybar");

  function updateStickyBar() {
    if (!sb) return;
    var addBtn = $(".add-to-cart");
    if (!addBtn) { sb.classList.remove("show"); document.body.classList.remove("stickybar-on"); return; }
    var r = addBtn.getBoundingClientRect();
    // show the bar whenever the main add to cart button is not on screen
    var inView = r.top < (window.innerHeight - 40) && r.bottom > 0;
    var show = window.scrollY > 300 && !inView;
    sb.classList.toggle("show", show);
    document.body.classList.toggle("stickybar-on", show);
  }

  window.addEventListener("scroll", function () {
    if (hdr) hdr.classList.toggle("scrolled", window.scrollY > 10);
    updateStickyBar();
  }, { passive: true });

  /* ---------------------------------------------------------
     MOBILE NAV
  --------------------------------------------------------- */
  var burger = $("#burger");
  if (burger) {
    burger.addEventListener("click", function () {
      var open = document.body.classList.toggle("mobile-nav-open");
      burger.setAttribute("aria-expanded", open);
    });
    $$(".nav a").forEach(function (a) {
      a.addEventListener("click", function () {
        document.body.classList.remove("mobile-nav-open");
        burger.setAttribute("aria-expanded", false);
      });
    });
  }

  /* ---------------------------------------------------------
     FAQ ACCORDION
  --------------------------------------------------------- */
  $$("#faq-list .q button").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var q = btn.parentElement;
      var ans = q.querySelector(".ans");
      var open = q.classList.toggle("open");
      btn.setAttribute("aria-expanded", open);
      ans.style.maxHeight = open ? ans.scrollHeight + "px" : 0;
    });
  });

  /* ---------------------------------------------------------
     REVEAL ON SCROLL
  --------------------------------------------------------- */
  if ("IntersectionObserver" in window && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    $$(".reveal").forEach(function (el) { io.observe(el); });
  } else {
    $$(".reveal").forEach(function (el) { el.classList.add("in"); });
  }

  /* ---------------------------------------------------------
     INIT
  --------------------------------------------------------- */
  document.addEventListener("DOMContentLoaded", function () {
    initProductSections();
    refreshCart();

    // label the sticky bar with the product title when available
    var buyTitle = $(".buy h2");
    var sbLabel = $("#stickybar .sinfo span");
    if (buyTitle && sbLabel) sbLabel.textContent = buyTitle.textContent.trim();

    // give the footer clearance for the sticky bar only on pages that have it
    if ($(".add-to-cart")) document.body.classList.add("has-buybar");

    updateStickyBar();
  });
})();
